<!--
 * @Description: 转签约
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-05-22 17:21:51
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <a-form ref="formRef" name="advanced_search" :model="form">
        <dc-layout-card title="合同信息（至少填写一个）" :span="12">
          <template #subTitle>
            <a-button type="primary" @click="hanleAdd" ghost>新增</a-button>
          </template>
          <template v-for="(item, index) in form.contracts" :key="index">
            <div class="cos-form-line" v-if="index"></div>
            <dc-form-item
              label="法务合同编码"
              :name="['contracts', index, 'contractCode']"
              :rules="{
                message: '请输入',
                required: true
              }"
            >
              <CosInput v-model:value="item.contractCode" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item
              label="签约主体"
              :name="['contracts', index, 'contractSubject']"
              :rules="{
                message: '请输入',
                required: true
              }"
            >
              <CosInput v-model:value="item.contractSubject" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item
              label="服务主体"
              :name="['contracts', index, 'serviceSubject']"
              :rules="{
                message: '请选择',
                validator: selectForNumberValidate,
                required: true
              }"
            >
              <ParamCodesSelect paramCode="fbu_service_body" appId="cos_fbu" v-model:value="item.serviceSubject" />
            </dc-form-item>
            <dc-form-item
              label="子客户代码"
              :span="12"
              :name="['contracts', index, 'arkCode']"
              :rules="{
                message: '请选择',
                required: true
              }"
            >
              <div class="flex">
                <GcCodeSelect
                  v-model:label="item.arkCode"
                  v-model:value="item.arkCodeId"
                  :cosId="route.query.cosId"
                  :requiredCosId="true"
                />
                <a-button
                  type="text"
                  danger
                  style="padding-right: 0"
                  @click="hanleDel(index)"
                  v-show="form.contracts && form.contracts.length > 1"
                  >删除</a-button
                >
              </div>
            </dc-form-item>
          </template>
        </dc-layout-card>
      </a-form>
      <cos-footer-button
        v-model:value="form"
        :resetValue="resetValue"
        :formRef="formRef"
        :permissionPage="permissionBasic"
        :disabled="false"
        :loading="loading"
        @submit="handleSubmit"
      ></cos-footer-button>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { turnedContract } from '@/api/gucangSales/customerCenter'
import GcCodeSelect from '@/components/GcCodeSelect'
import { layoutTags } from '@dc-platform/dc-interaction'
import { useRoute, useRouter } from 'vue-router'
import { selectForNumberValidate } from '@/utils/validate'
const router = useRouter()
const route = useRoute()
const formRef = ref()
const loading = ref(false)
const form = ref<{
  contracts: {
    arkCode?: string
    contractCode?: string
    contractSubject?: string
    serviceSubject?: number
  }[]
}>({
  contracts: [{}]
})
const resetValue = ref({
  contracts: [{}]
})
const permissionBasic = {
  save: 'fbu_potential_contract_btn'
}
const hanleAdd = () => {
  form.value.contracts.push({})
}
const hanleDel = (index: number) => {
  form.value.contracts.splice(index, 1)
}
const handleSubmit = () => {
  // 转签约 或者流失激活
  loading.value = true
  turnedContract({
    cosId: route.query.cosId,
    contracts: form.value.contracts
  })
    .then((res) => {
      layoutTags.close()
      message.success('操作成功')
      router.push({
        path: '/fbu/potential'
      })
    })
    .finally(() => {
      loading.value = false
    })
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuTurnToContract' }
</script>
